import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { ToastService, ToastType } from "@/core/services/toast.service";

@Injectable({
  providedIn: 'root',
})
export class ErrorStateService {
  private _errors = new Set<string>();
  private _subject = new Subject();

  public constructor(
    private readonly _toastService: ToastService,
  ) {
    this._subject
      .pipe(debounceTime(150))
      .subscribe(() => this.makeToasts());
  }

  public add(ne: HttpErrorResponse) {
    for (const error of ne.error.errors) {
      this._errors.add(error.message);
    }
    this._subject.next();
  }

  private makeToasts() {
    this._errors.forEach(element => {
      this._toastService.raiseMessage(element, ToastType.Error);
    });
    this._errors.clear();
  }
}
